@if (isCompleted()) {
  <div class="flex h-full">
    <thalea-sidebar />

    <div
      class="w-full min-h-full p-5 sm:p-10 overflow-x-hidden overflow-y-auto scrollbar-hide bg-(--background-color)"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <div
    class="h-full p-5 sm:p-10 overflow-x-hidden overflow-y-auto scrollbar-hide bg-(--background-color)"
  >
    <router-outlet></router-outlet>
  </div>
}
